import React, { useEffect } from "react";
import Button from "../global/Button";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { Controller, useForm } from "react-hook-form";
import Controll from "../academy/Controll";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import ValidateError from "../global/ValidateError";
import DateInput from "../global/DateInput";
import { getFormatedDate, toastMessage } from "../../utils/utils";
import MultiSearchableSelect from "../global/MultiSearchableSelect";
import {
  useAddUserToWalletMutation,
  useCreateWalletMutation,
  useGetAllWalletQuery,
  useGetAllWalletServicesQuery,
  useGetWalletUserByIdQuery,
} from "../../lib/redux/services/sections/Customers";
import { CURRENCY } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import MocionLogo from "../../assets/images/playerLogo_light.svg";
import { toast } from "react-toastify";
import SelectPlayerBox from "../booking/SelectPlayerBox";
import { useGetPlayersForBookingQuery } from "../../lib/redux/services/sections/Booking";
import { useGetAllPaymentMethodsQuery } from "../../lib/redux/services/sections/Payments";
import { useParams } from "react-router-dom";
import WalletCard from "./WalletCard";
import { changeViewMode } from "../../lib/redux/slices/controlSlice";
type props = {
  type: "new" | "edit" | "duplicate" | "view";
  rowId?: number;
  removeAnimation?: () => void;
  rowData: any;
};
type FormType = {
  player_id: string;
  payment_method_id: any;
};
function UserInfoForm({ type, rowId, removeAnimation, rowData }: props) {
  const { shared, inputs } = useGetDictionary();
  const dispatch = useDispatch();
  const { id } = useParams();
  const club_id = useSelector((state: any) => state.user.selectedClub);
  const { data, isLoading, isError, error, refetch, isFetching } =
    useGetWalletUserByIdQuery(
      {
        club_id: club_id,
        wallet_id: rowData?.id,
      },
      {}
    );
  useEffect(() => {
    //@ts-ignore
    dispatch(changeViewMode(true));
  }, []);
  return (
    <div className="w-full px-6 py-8 flex flex-col gap-8 dark:bg-primary h-[90%]">
      <div className="userInfo flex flex-col ">
        <div className="flex gap-5 items-center pb-5 ">
          <img
            src={data?.data?.player?.image_url || MocionLogo}
            alt=""
            className="w-[50px] h-[50px] rounded-full object-cover shadow-md"
          />
          <span className="font-bold">{data?.data?.player?.name}</span>
        </div>
        <div className="flex gap-2 pb-2">
          <span>Creation date:</span>
          <span>{data?.data?.activation}</span>
        </div>
        <div className="flex gap-2">
          <span>Expire date:</span>
          <span>{data?.data?.expiry}</span>
        </div>
      </div>
      <div className="yellowBox w-full bg-primaryYellow p-5 flex gap-1 flex-col items-center justify-center font-bold rounded-3xl">
        <p>Total balance</p>
        <p className="text-3xl">
          {parseFloat(data?.data?.remaining)?.toFixed(2)} {CURRENCY()}
        </p>
      </div>
      <div className="flex flex-col w-full gap-4 pb-4">
        <WalletCard
          title={"Bonus"}
          start_date={data?.data?.activation}
          amount={data?.data?.bonus}
        />
        <WalletCard
          title={"Credit"}
          start_date={data?.data?.activation}
          amount={data?.data?.balance}
        />
        {data?.data?.transaction_ids
          ?.filter(
            (item: any) =>
              item["consumed_service"] !== false &&
              item.transaction_type !== "cancel"
          )
          .map((item: any) => {
            return (
              <WalletCard
                key={item["consumed_service"]}
                booking_id={item?.id}
                service={item["consumed_service"]}
                title={item["consumed_service"]}
                booking_type={item?.type}
                start_date={item?.create_date}
                amount={item?.consumed_amount}
                transaction_type={item.transaction_type}
                type="minus"
              />
            );
          })}
      </div>
    </div>
  );
}

export default UserInfoForm;
